export const GET_ORG_LOAN_HISTORY_START =
  'GGET_ORG_LOAN_HISTORY_START';
export const GET_ORG_LOAN_HISTORY_ERROR =
  'GET_ORG_LOAN_HISTORY_ERROR';
export const GET_ORG_LOAN_HISTORY_SUCCESS =
  'GET_ORG_LOAN_HISTORY_SUCCESS';
